import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";
import { ACCOUNT_OPT } from "../../../data/Constants";

const AccountTypeFilter = ({
  selectedAccountType,      
  setSelectedAccountType,
}) => {
  return (
    <div className="timesheet_dropdown_wrapper">
      <SelectDropdown
        options={ACCOUNT_OPT}
        name="Account Type"
        value={selectedAccountType}
        setSelectedOption={setSelectedAccountType}
        isDisable={false}       
        isSearchable={true}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default AccountTypeFilter;
